var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.buttonClass},_vm.$listeners),[_vm._t("default",[(_vm.icon)?_c('ur-icon',{attrs:{"icon":_vm.icon,"sm":"","iconType":"picto"}}):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }